import * as loglevel from 'loglevel';
import type { App } from 'vue';
import { AppError } from './AppError';
import { wrapError } from './wrapError';

export function configureErrorHandler(vue: App<Element>, options: { errorCode: string }) {
  vue.config.errorHandler = (error, _, info) => {
    const appError = wrapError(error, options.errorCode, 'unhandled top-level error', {
      data: { info },
    });

    logError(appError);
  };
}

// singleton listeners for log error events
const listeners: Array<(error: AppError) => void> = [];

export function addLogErrorListener(listener: (error: AppError) => void): void {
  listeners.push(listener);
}

export function logError(error: AppError, logger: loglevel.Logger = loglevel): AppError {
  logger.error('log_error', error.toJSON(), error);

  // push to each listener
  listeners.forEach((listener) => {
    try {
      listener(error);
    } catch (e) {
      logger.error('log_error_listener', 'failed to call error listener', e);
    }
  });

  return error;
}
